module.exports = __webpack_public_path__ + "img/empty.185dccd7.svg";